import { Navigate, Outlet } from "react-router-dom";

const AdminPublicRoute = () => {
  const token = localStorage.getItem("admin_token");

  if (token) {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
};

export default AdminPublicRoute;
